import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { User, Lock, Eye, EyeOff } from 'lucide-react';
const BG_URL = 'https://cdn.magicpatterns.com/uploads/jiEwbNvMzMQ7hraX7mj8EN/Chimbuk-Hills.jpg_1.png';
const GOV_LOGO_URL = 'https://cdn.magicpatterns.com/uploads/dU3qapA9H2XyT3LbpNWDjq/Government_Seal_of_Bangladesh.svg_1.png';
export function AdminLogin() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/admin');
  };
  return <div className="admin-theme relative h-screen w-full overflow-hidden font-bangla" data-id="element-150">
      {/* Background image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url('${BG_URL}')`,
      opacity: 0.6
    }} data-id="element-151" />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-900/40 via-slate-900/40 to-emerald-950/60" data-id="element-152" />

      {/* Centered Login Card */}
      <div className="relative z-10 flex items-center justify-center h-full p-6" data-id="element-153">
        <div className="w-full max-w-md bg-white/95 backdrop-blur-md rounded-3xl shadow-2xl border border-white/80 p-8 md:p-10" data-id="element-154">
          {/* Government Header */}
          <div className="flex flex-col items-center text-center mb-7" data-id="element-155">
            <img src={GOV_LOGO_URL} alt="Government Seal of Bangladesh" className="w-20 h-20 object-contain mb-4" data-id="element-156" />
            <p className="text-sm font-semibold text-slate-600" data-id="element-157">
              গণপ্রজাতন্ত্রী বাংলাদেশ সরকার
            </p>
            <p className="text-sm font-bold text-[#006A4E]" data-id="element-158">
              জেলা প্রশাসন, বান্দরবন পার্বত্য জেলা
            </p>
            <div className="w-12 h-0.5 bg-[#006A4E] my-4 rounded-full" data-id="element-159" />
            <p className="text-xs font-semibold tracking-widest uppercase text-slate-500 mb-1" data-id="element-160">
              চিম্বুক পাহাড় টিকিটিং সিস্টেম
            </p>
            <h1 className="text-3xl font-bold text-slate-900" data-id="element-161">লগইন করুন</h1>
          </div>

          <form onSubmit={handleLogin} className="space-y-5" data-id="element-162">
            <div className="space-y-2" data-id="element-163">
              <label className="text-sm font-bold text-slate-800" data-id="element-164">
                ব্যবহারকারীর নাম
              </label>
              <Input icon={<User className="w-5 h-5" data-id="element-166" />} type="text" placeholder="ইউজারনেম লিখুন" required className="h-14" data-id="element-165" />
            </div>

            <div className="space-y-2" data-id="element-167">
              <label className="text-sm font-bold text-slate-800" data-id="element-168">
                পাসওয়ার্ড
              </label>
              <div className="relative" data-id="element-169">
                <Input icon={<Lock className="w-5 h-5" data-id="element-171" />} type={showPassword ? 'text' : 'password'} placeholder="পাসওয়ার্ড লিখুন" required className="h-14 pr-12" data-id="element-170" />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600" data-id="element-172">
                  {showPassword ? <EyeOff className="w-5 h-5" data-id="element-173" /> : <Eye className="w-5 h-5" data-id="element-174" />}
                </button>
              </div>
            </div>

            <Button type="submit" className="w-full h-14 text-lg font-bold mt-2" data-id="element-175">
              লগইন
            </Button>
          </form>
        </div>
      </div>
    </div>;
}